import React from 'react'
import { type FilterOption } from '../data/download-filters';
import { getFilters } from '../js/download-match-utility';

const DownloadsContext = React.createContext(null);

type Props = {
    defaultOS: string,
    params: URLSearchParams,
    children: React.JSX.Element[]|React.JSX.Element,    
}

export type DownloadsStateObject = {
    filters: Record<string, FilterOption[]>,
}

const DownloadsProvider = ({defaultOS, params, children}: Props) => {
    if (!params){
        params = new URLSearchParams();
    }
    let familyStr = params.get('product') || '';
    familyStr = decodeURIComponent(familyStr);
    const familyOptions = familyStr == '' ? [] : familyStr.split('+');
    let hostStr = params.get('host') || '';
    hostStr = decodeURIComponent(hostStr);
    const hostOptions = hostStr == '' ? [] : hostStr.split('+');
    let osStr = params.get('os') || '';
    osStr = decodeURIComponent(osStr);
    const osOptions = osStr == '' ? [] : osStr.split('+');
    if (defaultOS && osOptions.length == 0){
        osOptions.push(defaultOS);
    }

    const [downloadsState, setDownloadsState] = React.useState<DownloadsStateObject>(
        {
            filters: {
                family: getFilters('family', familyOptions),
                host: getFilters('host', hostOptions),
                os: getFilters('os', osOptions)
            }
        }
    );
    return (
        <DownloadsContext.Provider value={[downloadsState, setDownloadsState]}>
            {children}
        </DownloadsContext.Provider>
    )
}

export {DownloadsProvider, DownloadsContext};